import React, { useState } from 'react';
import useAuthGuard from '../hooks/useAuthGuard';
import Layout from '../components/Layout';
import { API_BASE_URL } from '../config';
import apiFetch from '../utils/apiFetch';

export default function StoreImport() {
  useAuthGuard();

  const [fileUrl, setFileUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    setError('');

    try {
      const res = await apiFetch(`${API_BASE_URL}/admin/import/stores`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fileUrl }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || data.error || `HTTP ${res.status}`);
      }

      const data = await res.json();
      setResult(data.data || data);
      setFileUrl('');
    } catch (e) {
      setError(e.message || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="mb-4">
        <h2 className="page-title">Store Import</h2>
        <p className="page-subtitle">Import from CSV</p>
      </div>

      <div className="row">
        <div className="col-12 col-lg-8">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="fileUrl" className="form-label" style={{ fontSize: '0.8125rem', fontWeight: 600 }}>
                    CSV file URL
                  </label>
                  <input
                    type="url"
                    id="fileUrl"
                    className="form-control"
                    placeholder="https://example.com/stores.csv"
                    value={fileUrl}
                    onChange={(e) => setFileUrl(e.target.value)}
                    required
                    style={{ fontSize: '0.8125rem' }}
                  />
                  <div className="form-text" style={{ fontSize: '0.75rem' }}>
                    CSV URL
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-phoenix-primary"
                  disabled={loading || !fileUrl}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Importing...
                    </>
                  ) : (
                    'Import'
                  )}
                </button>
              </form>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              {error}
            </div>
          )}

          {result && (
            <div className="alert alert-success mt-3" role="alert">
              <h6 className="alert-heading" style={{ fontSize: '0.875rem' }}>Queued</h6>
              <p className="mb-0" style={{ fontSize: '0.8125rem' }}>{result.message || 'Import queued'}</p>
            </div>
          )}
        </div>

        <div className="col-12 col-lg-4">
          <div className="card">
            <div className="card-body">
              <h6 style={{ fontSize: '0.875rem', fontWeight: 700 }}>CSV Format</h6>
              <p className="small mb-2" style={{ color: '#8a94ad' }}>
                Columns:
              </p>
              <ul className="small mb-0" style={{ color: '#525b75' }}>
                <li>name (required)</li>
                <li>address (required)</li>
                <li>latitude</li>
                <li>longitude</li>
                <li>phone</li>
                <li>website</li>
                <li>opening_hours</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
